import { usePrivy, useUser } from '@privy-io/react-auth';

import { useWalletAccess } from './wallet-access-provider';

export function useWalletSecurityReady(): boolean {
  const { ready, authenticated } = usePrivy();
  const { user } = useUser();
  const { access, isUnlocked } = useWalletAccess();
  return ready && authenticated && isUnlocked && Boolean(user && user.id === access?.privyUserId);
}
